import { BaseClass } from 'digicon-events-base';
import { OverrideLogin } from '../modules/OverrideLoginModule';
import mainHTML from '../../../main.module.html';
import { DataUtils } from '../../js/utils/dataUtils';
import { formInput } from 'digicon-web-forms/forms';
import { i18n } from 'digicon-web-localization/localization';

export class LoginManager extends BaseClass {
    constructor(modules, managers) {
        super();

        this.modules = modules;
        this.managers = managers;

        this.managers.loginManager = this;
    }

    init(onLogin) {
        this._onLoginCallback = onLogin;
        this.modules.login = new OverrideLogin({ register: true, container: 'loginContainer', showCloseButton: false });
        new DataUtils().setDomain(this.modules.login.data);

        let formData = [
            {
                type: formInput.TEXT,
                id: 'name',
                mandatory: true,
                placeholder: i18n('lgnUserNamePlc'),
                classList: ['loginUI_input']
            },
            {
                type: formInput.EMAIL,
                id: 'email',
                mandatory: true,
                placeholder: i18n('lgnEmailPlc')
            },
            {
                type: formInput.PASSWORD,
                id: 'password',
                mandatory: true,
                placeholder: i18n('lgnPasswordPlc')
            },
            {
                type: formInput.PASSWORD,
                id: 'repassword',
                mandatory: true,
                placeholder: i18n('lgnRepeatPasswordPlc')
            }
        ];

        let extraFormData = [
            {
                type: formInput.LABEL,
                id: 'type',
                label: i18n('lbType')
            },
            {
                type: formInput.CHECKBOX,
                id: "TipoFloor",
                defAttributeId: 26, //id metabackend de definición de atributo
				attributeTypeId: 1002,
                label: i18n('lgPVfloor')
            },
            {
                type: formInput.CHECKBOX,
                id: "TipoFloat",
                defAttributeId: 26, //id metabackend de definición de atributo
				attributeTypeId: 1003,
                label: i18n('lgPVfloating')
            }
        ];
        this.modules.login._register.setRegisterFormFullData(formData);
        this.modules.login._register.setRegisterFormExtraData(extraFormData);
        this.modules.login.subscribe('onLogin', async (userName) => {
            this._onLogin(userName);
        });

        this._launchLogin();
        //this._launchLoginDebug();
    }

    _launchLogin() {
        //LOGIN FORM
        this.modules.login.openLoginForm();
        document.getElementById('splash').dataset.visible = false;
    }

    _onLogin(user) {
        //store the login container
        this.__loginContainer = document.body.innerHTML;

        document.body.innerHTML = mainHTML;

        if (this._onLoginCallback) this._onLoginCallback(user);
    }

    attempRegister(){

    }

    logOut() {
        this.modules.login.logout();
        document.body.innerHTML = this.__loginContainer;
        this.modules.login.openLoginForm();
    }
}